import { render, staticRenderFns } from "./IntellectualProperty.vue?vue&type=template&id=35c64f45&scoped=true&"
import script from "./IntellectualProperty.vue?vue&type=script&lang=ts&"
export * from "./IntellectualProperty.vue?vue&type=script&lang=ts&"
import style0 from "./IntellectualProperty.vue?vue&type=style&index=0&id=35c64f45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c64f45",
  null
  
)

export default component.exports